import { JobFromAPI } from '../types';
import { transformJobs } from './api-transforms';
import { notEmpty } from './api-utils';
import apiRequest from './apiRequest';

type ApiResponse = {
  jobs: JobFromAPI[];
  nextToken?: string;
};

export default async function getJobs(
  limit?: number,
  nextToken?: string,
  sortAscending?: boolean,
  favoritesOnly?: boolean,
) {
  const urlParams = new URLSearchParams();
  if (limit) {
    urlParams.set('limit', limit.toString());
  }
  if (nextToken) {
    urlParams.set('nextToken', nextToken);
  }
  if (sortAscending) {
    urlParams.set('sortAscending', sortAscending.toString());
  }
  if (favoritesOnly) {
    urlParams.set('favoritesOnly', 'true');
  }
  const res = await apiRequest<ApiResponse>(
    'mogen-orchestration',
    `/jobs${urlParams.toString() ? '?' : ''}${urlParams.toString()}`,
  );

  return {
    error: res.error,
    data: {
      nextToken: res.data?.nextToken,
      jobs: transformJobs(res.data?.jobs),
    },
  };
}
